import React, { useEffect, useRef, useState } from "react";
import queryString from "query-string";
import axios from "axios";
import { Box, Divider, Flex, Grid } from "@chakra-ui/react";

import {
  ASSETS_SLIDER_PANEL,
  AssetTypes,
  FABRIC_SVG_ELEMENT,
  FABRIC_VIDEO_ELEMENT,
  GIPHY_SLIDER_PANEL,
  ICONS_SLIDER_PANEL,
  IMAGES_SLIDER_PANEL,
  MUSIC_SLIDER_PANEL,
  VIDEO_SLIDER_PANEL,
} from "../details/constants";
import { FETCH_RECENTS } from "../../_actions/endpoints";

import TLDRSwiper from "./TLDRSwiper";
import {
  GalleryTypeHeaderTitle,
  ImageItem,
  ImageItemWithoutDrag,
} from "./statelessView";
import { useSelector, useDispatch, connect } from "react-redux";
import {
  GIFSources,
  IconsSources,
  ImageSources,
  MusicSources,
  SourceTypes,
  VideoSources,
} from "../../_actions/types";
import { handleHTTPError } from "../../_actions/errorHandlerActions";
import { getAlignPosition } from "../../_utils/common";
import MusicItem from "../details/sidebarPanels/mediaPanel/AudioList/MusicItem";
import { defaultMusicPayload } from "../canvas/constants/defaults";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { closeSlider } from "../../_actions/sidebarSliderActions";

const recentlyUsedMediaParams = {
  // containerClass: "recent-swiper",
  slidesPerView: 3,
  noSwiping: false,
  freeMode: true,
  shouldSwiperUpdate: true,
  runCallbacksOnInit: true,
  containerClass: "recent-swiper",
  mousewheel: true,
  lazy: true,
  preloadImages: false,
};

const imageSourceMappings = {
  [ImageSources.UNSPLASH]: SourceTypes.UNSPLASH,
  [ImageSources.PEXELS]: SourceTypes.PEXELS,
  [ImageSources.PIXABAY]: SourceTypes.PIXABAY,
  [ImageSources.SHOPIFY]: SourceTypes.SHOPIFY,
  [ImageSources.SHUTTERSTOCK]: SourceTypes.SHUTTERSTOCK,
  [ImageSources.GOOGLE_DRIVE]: SourceTypes.GOOGLE_DRIVE,
  [ImageSources.STORYBLOCKS]: SourceTypes.STORYBLOCKS_GRAPHIC,
};

const videoSourceMappings = {
  [VideoSources.PIXABAY]: SourceTypes.PIXABAY,
  [VideoSources.PEXELS]: SourceTypes.PEXELS,
  [VideoSources.SHUTTERSTOCK]: SourceTypes.SHUTTERSTOCK,
  [VideoSources.STORYBLOCKS]: SourceTypes.STORYBLOCKS_VIDEO,
};

const audioSourceMappings = {
  [MusicSources.STORYBLOCKS]: SourceTypes.STORYBLOCKS_AUDIO,
};

const iconSourceMappings = {
  [IconsSources.FLATICON]: SourceTypes.FLATICON,
  [IconsSources.BRANDFETCH]: SourceTypes.BRANDFETCH,
  [IconsSources.ICONS8]: SourceTypes.ICONS8_ICON,
  [IconsSources.NOUN_PROJECT]: SourceTypes.NOUN_PROJECT,
};

const gifSourceMappings = {
  [GIFSources.GIPHY]: SourceTypes.GIPHY,
};

const preparePayload = (assetType, data, contentSize, activePageId) => {
  switch (assetType) {
    case "audio":
      return {
        ...defaultMusicPayload,
        src: data?.thumbnail,
        source: data?.source,
        source_id: data?.source_id,
        duration: data?.extra_data?.duration,
        title: data?.extra_data?.title,
        cover: data?.thumbnail_cover_image,
      };
    case "giphy":
      return {
        mime: "giphy",
        payload: {
          name: "New Gif",
          src: data?.thumbnail,
          type: "gif",
          height: data.thumbnail_height,
          width: data.thumbnail_width,
          cover: data?.thumbnail_cover_image,
          userProperty: {
            source_id: data?.source_id,
          },
        },
        content: {
          source: SourceTypes.GIPHY,
          source_id: data?.source_id,
          source_url: data?.source_url,
          url: data?.thumbnail,
          meta: {},
        },
      };
    case "shape":
      return {
        mime: "shape",
        type: "icon",
        payload: {
          type: FABRIC_SVG_ELEMENT,
          superType: "svg",
          userProperty: {
            // source_id: data.id,
            source_id: null,
          },
          svg: data?.thumbnail,
          cover: data?.thumbnail_cover_image,
        },
        content: {
          source: data.source,
          source_id: data.source_id,
          source_url: data.source_url,
          meta: {},
        },
      };
    case "video":
      const elementSize = {
        width: data.thumbnail_width,
        height: data.thumbnail_height,
      };
      return {
        mime: "video",
        payload: {
          superType: "image",
          type: FABRIC_VIDEO_ELEMENT,
          width: elementSize.width,
          height: elementSize.height,
          name: "New video",
          autoplay: false,
          // muted: false,
          loop: false,
          src: data.thumbnail,
          size: elementSize,
          position: getAlignPosition(
            elementSize,
            { x: 0, y: 0 },
            "middle-center",
            contentSize
          ),
          container: activePageId,
          cover: data?.thumbnail_cover_image,
          startTime: 0,
          endTime: data?.extra_data?.duration,
          duration: data?.extra_data?.duration,
          userProperty: {
            source_id: data.source_id,
          },
          volume: 1,
        },
        content: {
          source: data.source,
          source_id: data.source_id,
          source_url: data.source_url,
          url: data?.extra_data?.cover,
          // TODO: omit `duration` after full deprecation
          meta: { video: data, duration: data?.extra_data?.duration },
        },
      };
    case "image":
    default:
      return {
        mime: "image",
        payload: {
          name: "New Image",
          src: data.thumbnail,
          type: "image",
          height: data.thumbnail_height,
          width: data.thumbnail_width,
          userProperty: {
            source_id: data.source_id,
          },
          cover: data?.thumbnail_cover_image,
        },
        content: {
          source: data.source,
          source_url: data.thumbnail,
          source_id: data.source_id,
        },
      };
  }
};

/**
 *
 * @param sliderPanelType
 * @param imageSource
 * @param videoSource
 * @param iconsSource
 * @param musicSource
 * @param gifSource
 * @param videoSource
 * @param iconsSource
 * @param musicSource
 * @param gifSource
 * @param videoSource
 * @param iconsSource
 * @param musicSource
 * @param gifSource
 * @returns {[string, null]|[(string|string), number]}  returns [source, asset_type]
 */
const getCurrentAssetTypeAndSourceFromProps = ({
  sliderPanelType,
  imageSource,
  videoSource,
  iconsSource,
  musicSource,
  gifSource,
}) => {
  switch (sliderPanelType) {
    case ASSETS_SLIDER_PANEL:
      return [SourceTypes.TLDR_ASSETS, null];
    case ICONS_SLIDER_PANEL:
      return [
        iconSourceMappings[iconsSource] ?? SourceTypes.TLDR_ASSETS,
        AssetTypes.ASSET_SHAPE,
      ];
    case GIPHY_SLIDER_PANEL:
      return [
        gifSourceMappings[gifSource] ?? SourceTypes.TLDR_ASSETS,
        AssetTypes.ASSET_GIF,
      ];
    case MUSIC_SLIDER_PANEL:
      return [
        audioSourceMappings[musicSource] ?? SourceTypes.TLDR_ASSETS,
        AssetTypes.ASSET_AUDIO,
      ];
    case VIDEO_SLIDER_PANEL:
      return [
        videoSourceMappings[videoSource] ?? SourceTypes.TLDR_ASSETS,
        AssetTypes.ASSET_VIDEO,
      ];
    case IMAGES_SLIDER_PANEL:
      return [
        imageSourceMappings[imageSource] ?? SourceTypes.TLDR_ASSETS,
        AssetTypes.ASSET_IMAGE,
      ];
    default:
      return [
        imageSourceMappings[imageSource] ?? SourceTypes.TLDR_ASSETS,
        AssetTypes.ASSET_IMAGE,
      ];
  }
};

const RecentlyUsedMedia = (props) => {
  const {
    onClickItem,
    onDragItem,
    withoutDragAndDropContext,
    onToggleViewAll,
    viewAll,
  } = props;

  const { t } = useTranslation(["studio", "common"]);
  const abortController = useRef(new AbortController());
  const { sidebarSlider, activePageId, story } = useSelector((state) => ({
    sidebarSlider: state.sidebarSlider,
    activePageId: state.editor?.activePage?.id,
    story: state.story,
  }));
  const dispatch = useDispatch();

  const [recentlyUsedMediaState, setRecentlyUsedMediaState] = useState({
    isLoading: false,
    data: [],
  });

  const [audioElRef, setAudioElRef] = useState(null);

  // Fetch recently used media for selected asset type
  const fetchRecentlyUsedMedia = async () => {
    const [source, asset_type] =
      getCurrentAssetTypeAndSourceFromProps(sidebarSlider);
    const query = queryString.stringify({
      asset_type: asset_type,
      source: source,
    });
    setRecentlyUsedMediaState({
      isLoading: true,
      data: [],
    });
    try {
      const response = await axios.get(`${FETCH_RECENTS}?${query}`, {
        signal: abortController.current
          ? abortController.current.signal
          : undefined,
      });
      if (response.status === 200) {
        if (response.data) {
          setRecentlyUsedMediaState({
            isLoading: false,
            data: response.data.results.map((item) => {
              const payload = preparePayload(
                item.asset_type,
                item,
                story?.contentSize,
                activePageId
              );
              return payload;
            }),
          });
        }
      }
    } catch (e) {
      dispatch(handleHTTPError(e, props));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchRecentlyUsedMedia();
    };
    // Cancel ongoing requests
    if (abortController.current) {
      abortController.current.abort();
    }
    abortController.current = new AbortController();
    fetchData();

    return () => {
      // Cleanup on component unmount
      if (abortController.current) abortController.current.abort();
    };
  }, [
    sidebarSlider.sliderPanelType,
    sidebarSlider.imageSource,
    sidebarSlider.videoSource,
    sidebarSlider.iconsSource,
    sidebarSlider.musicSource,
    sidebarSlider.gifSource,
  ]);

  if (!recentlyUsedMediaState.data.length) return null;

  const itemsToRender = recentlyUsedMediaState.data.map((item, idx) => {
    if (item.mime === "audio") {
      return (
        <Box
          key={idx}
          width={`${viewAll ? 100 : 50}%`}
          p={viewAll ? 0 : 2}
          minW={0}
          h="100%"
          pos="relative"
        >
          <MusicItem
            key={idx}
            data={{
              ...item,
              title: item?.title,
              duration: item?.duration,
              cover: item?.cover,
              src: item?.src,
            }}
            onClick={(e) => {
              onClickItem(item);
            }}
            onPlay={(audioEl) => {
              if (audioElRef) audioElRef.stop();
              setAudioElRef(audioEl.current);
            }}
          />
        </Box>
      );
    }

    return (
      <Box
        key={idx}
        onClick={() => {
          onClickItem(item);
          props.isMobileView && props.closeSlider();
        }}
        onDragStart={(e) => onDragItem(e, item)}
        cursor="pointer"
        pos="relative"
        className="item item-element element-slider-item"
        mr={3}
        w={viewAll ? "100%" : "33%"}
        sx={{
          img: {
            maxHeight: "100%",
          },
        }}
      >
        {withoutDragAndDropContext ? (
          <ImageItemWithoutDrag
            data={item}
            url={item?.payload?.cover ?? item?.payload?.src}
            alt={"Image"}
            width={item.payload.width}
            height={item.payload.height}
            source={item.content.source}
            showOverlayInfo={false}
            isUsedInSwiper={false}
          />
        ) : (
          <ImageItem
            data={item}
            url={item?.payload?.cover ?? item?.payload?.src}
            alt={"Image"}
            width={item.payload.width}
            height={item.payload.height}
            source={item.content.source}
            showOverlayInfo={false}
            isUsedInSwiper={false}
          />
        )}
      </Box>
    );
  });

  const containerStyles = viewAll
    ? {
        display: "flex",
        flexDirection: "column",
        flexGrow: "1",
      }
    : {};

  return (
    <>
      <Box
        w="100%"
        pb={2}
        pr={4}
        sx={{
          ...containerStyles,
          ".recent-swiper": {
            overflow: "hidden",
            // height: "100px",
          },
        }}
      >
        <GalleryTypeHeaderTitle
          moreOpened={viewAll}
          title={viewAll ? t("common:back") : t("sidebar.recently_used")}
          toggleMore={onToggleViewAll}
        />
        {viewAll ? (
          <Flex
            grow="1"
            basis="0"
            overflow="scroll"
            width="calc(100% + 10px)"
            sx={{
              "&::-webkit-scrollbar-track": {
                bg: "transparent",
              },
              "&::-webkit-scrollbar-track-piece": {
                bg: "transparent",
              },
              "&::-webkit-scrollbar-corner": {
                bg: "transparent",
              },
            }}
          >
            <Grid
              templateColumns="repeat(2, 1fr)"
              gap="3"
              mr="15px"
              alignContent="start"
              w="100%"
            >
              {itemsToRender}
            </Grid>
          </Flex>
        ) : (
          <TLDRSwiper swiperParams={recentlyUsedMediaParams}>
            {itemsToRender}
          </TLDRSwiper>
        )}
      </Box>
      <Divider w={`calc(100% - 16px)`} my={1} mx={0}/>
    </>
  );
};

RecentlyUsedMedia.defaultProps = {
  assetType: AssetTypes.ASSET_IMAGE,
  onClickItem: () => {},
  withoutDragAndDropContext: false,
  onDragItem: () => {},
};

RecentlyUsedMedia.propTypes = {
  onClickItem: PropTypes.func,
  onDragItem: PropTypes.func,
  withoutDragAndDropContext: PropTypes.bool,
  viewAll: PropTypes.bool,
  onToggleViewAll: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isMobileView:state.app.isMobileView
});

const mapDispatchToProps = (dispatch) => ({
  closeSlider: () => dispatch(closeSlider()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecentlyUsedMedia);
